const  zh_Hk = {
    9000001:" 2023聖誕杯",
    9000002:"SuperEx合約錦標賽",
    9000003:"贏取30,000USDT競賽獎金",
    9000004:"參賽人數",
    9000005:"已解鎖獎池（USDT）",
    9000006:"交易量排名資格賽",
    9000007:"盈利率排名資格賽",
    9000008:"盈利額排名資格賽 ",
    9000009:`交易量排名賽，解鎖最高 <span style="color: #ffc72b;">20,000</span> USDT 獎金池`,
    9000010:"根據參賽人數解鎖對應獎池，參賽人數越多解鎖獎池越大，最高20,000USDT獎金池 ",
    9000011:"獎池金額",
    9000012:"活動期間每天10:00（UTC）更新",
    9000013:"獎勵預估",
    9000014:"期間纍計合約交易金額",
    9000015:"獎勵規則 ",
    9000016:"根據參賽人數解鎖對應獎池，參賽人數越多解鎖獎池越大，最高20,000USDT獎金池",
    9000017:"獎池金額（USDT）",
    9000018:"活動盈利率排名",
    9000019:"報名",
    9000020:"活動盈利額排名",
    9000021:"已結束",
    9000022:`盈利率排名賽，瓜分 <span style="color: #ffc72b;">{moneyPond}</span> USDT 獎金`,
    9000023:`盈利額排名賽，瓜分 <span style="color: #ffc72b;">{moneyPond}</span> USDT 獎金`,
    9000024:"累计合約盈利率",
    9000025:"纍計合约盈利金額",
    9000026:"未開始",
    9000027:"參賽用戶盈利額排名前50名獲得獎勵，可參考交易排名獎勵規則獲取贈金獎勵",
    9000028:"參賽用戶盈利率排名前50名可獲得獎勵，可參考交易排名獎勵規則獲取獎勵",
    9000029:"活動交易額排名",
    9000030:"註冊成功",
    9000031:"下載App",
    9000032:"返回首頁",

    //合约交易积分
    9100001: '攢積分',
    9100002: '得空投',
    9100003: '兌獎勵',
    9100004: '積分餘額',
    9100005: '明細',
    9100006: '簽到積分',
    9100007: '交易積分',
    9100008: '邀請積分',
    9100009: '獎勵積分',
    9100010: '幸運抽獎',
    9100011: '獲取積分',
    9100012: '積分規則',
    9100013: '積分明細',
    9100014: '您需要報名才能參與此活動，點擊即可參與',
    9100015: '已連續交易 {day} 天並獲得 {num} 積分',
    9100016: '今日已得 {num} 積分',
    9100017: '積分獎池',
    9100018: '每次抽獎消耗 {point} 積分，每天最多抽 {num} 次',
    9100019: '今日抽獎次數',
    9100020: '用戶',
    9100021: '積分',
    9100022: '積分餘額不足',
    9100023: '積分餘額不足，請獲取積分後再參與抽獎',
    9100024: '抽獎次數已達上限',
    9100025: '今日抽獎次數已達上限，請明日再試。',
    9100026: '如何獲得積分',
    9100027: '報名參與合約交易獲積分活動，才能獲得積分',
    9100028: '參與報名成功',
    9100029: '您已報名參與合約交易獲積分活動，去交易獲得更多積分吧（將不再享受返傭返現獎勵）',
    9100030: '取消報名後，將不再獲得積分，您確定要取消報名嗎？',
    9100031: '交易積分活動中心',
    9100032: '獲取積分',
    9100033: '您需要報名才能參與此活動，點擊即可參與',
    9100034: '連續參與合約交易即可獲得積分',
    9100035: '用戶在合約市場產生的所有交易行為即可獲取積分',
    9100036: '排行榜積分',
    9100037: '每日交易排行榜前五給與額外的獎勵積分',
    9100038: '被邀請人產生積分，邀請人可獲得獎勵積分',
    9100039: '{guy} 已經中獎<span style="color:#D9A31A"> {num} 積分</span>',
    9100040: '立即抽獎',
    9100041: '恭喜您獲得了',
    9100042: '全部類型',
    9100043: '留在此頁',
    9100044: '參與報名',
    9100045: '繼續交易',
    9100046: '暫無正在進行的活動，敬請期待...',
    9100047: '兌SCS代幣',
    9100048: '',
    9100049: '',

    9100050: '日期',
    9100051: '起始時間',
    9100052: '結束時間',
    9100053: '到',
    9100054: '類型',

    9100055: '可獲積分=交易額*1%（難度隨著平台總交易量的上升會進一步調整）',
    9100056: '例如：用戶使用保證金100USDT*100X=10000U的倉位',
    9100057: '那麼只需要100USDT的保證金即可獲得100積分',
    9100058: '交易積分是獲取平台代幣SCS的唯一渠道',
    9100059: '額外獎勵積分=當日積分總額*名次獎勵比例',
    9100060: '名次',
    9100061: '第一名',
    9100062: '第二名',
    9100063: '第三名',
    9100064: '第四名',
    9100065: '第五名',
    9100066: '被邀請人產生積分，邀請人可獲得獎勵積分',
    9100067: '等級係數',
    9100068: '計算公式：獲得推廣積分= 被邀請人獲得積分 * 等級係數',
    9100069: '等級係數會根據實際狀況進行調整',
    9100070: '例如：用戶B參與積分活動，其邀請人為用戶A，且用戶A邀請數等級已達到Level3，用戶B累計獲得積分=360,000；',
    9100071: '那麼用戶A累計可獲的推廣積分=360000* 30%=108,000',
    9100072:'獎勵係數',
    9100073:'1个交易用戶 ',
    9100074:'交易量達到500W',
    9100075:'交易量達到2000W',

    9100076:'劃轉',
}
export default zh_Hk



// WEBPACK FOOTER //
// ./src/i18n/langs/languageJame/zh-HK.js